__turbopack_context__.v({
  "errorCloseButton": "notifications-module__WRhCwa__errorCloseButton",
  "errorDescription": "notifications-module__WRhCwa__errorDescription",
  "errorRoot": "notifications-module__WRhCwa__errorRoot",
  "errorTitle": "notifications-module__WRhCwa__errorTitle",
  "infoCloseButton": "notifications-module__WRhCwa__infoCloseButton",
  "infoDescription": "notifications-module__WRhCwa__infoDescription",
  "infoRoot": "notifications-module__WRhCwa__infoRoot",
  "infoTitle": "notifications-module__WRhCwa__infoTitle",
  "successCloseButton": "notifications-module__WRhCwa__successCloseButton",
  "successDescription": "notifications-module__WRhCwa__successDescription",
  "successRoot": "notifications-module__WRhCwa__successRoot",
  "successTitle": "notifications-module__WRhCwa__successTitle",
  "warningCloseButton": "notifications-module__WRhCwa__warningCloseButton",
  "warningDescription": "notifications-module__WRhCwa__warningDescription",
  "warningRoot": "notifications-module__WRhCwa__warningRoot",
  "warningTitle": "notifications-module__WRhCwa__warningTitle",
});
